module.exports = __webpack_public_path__ + "graphics/checkout-confirmation-tick.ckh.d1738c35b84448941873dafbccc5f82a.svg";